export const CURRENT_FORM_IMPORT = "CurrentFormImport";
export const AUTH_CONTEXT = "AuthContext";
export const EXPLORE_SAVED_SCHOOL_IDS = "ExploreSavedSchoolIDs";
export const EXPLORE_SAVED_SCHOOL_REF_IDS = "ExploreSavedSchoolRefIDs";
export const PREFERRED_LANG = "AvelaPreferredLang";
